import { useQuery } from "@tanstack/react-query";

import { CouponsQueryKeys } from "./couponsQueryKeys";
import { getCoupon, getLastCoupon } from "@/api/coupons";
import { useLocale } from "next-intl";

export const useCoupon = (couponId: string | null) => {
  const locale = useLocale();

  return useQuery({
    queryKey: [CouponsQueryKeys.Single, couponId],
    enabled: Boolean(couponId),
    queryFn: ({ signal }) => {
      const params = { couponId: couponId!, lang: locale };
      return getCoupon({ signal, params });
    },
    refetchInterval: (query) => {
      const data = query.state.data;
      const hasLive = data?.selections?.some(
        (s) => s.matchStatus === "live"
      );
      return hasLive ? 30_000 : false;
    },
  });
};

export const useLastCoupon = (enabled: boolean) => {
  const locale = useLocale();

  return useQuery({
    queryKey: [CouponsQueryKeys.LastCoupon, locale],
    retry: false,
    queryFn: ({ signal }) => {
      return getLastCoupon({ signal, params: { lang: locale } });
    },
    enabled,
  });
};
